import React, { createContext, useContext, useState, useEffect } from 'react';
import { createMongoAbility, AbilityBuilder } from '@casl/ability';
import { useAuth } from './AuthContext';
import { ACTIONS, SUBJECTS } from '../constants/permissions';

const AbilityContext = createContext();

const detectSubjectType = (subject) => {
    if (subject && typeof subject === 'object' && subject.__type) {
        return subject.__type;
    }
    return typeof subject === 'string' ? subject : null;
};

const defineRulesForGuest = () => {
    const { can, build } = new AbilityBuilder(createMongoAbility);

    can(ACTIONS.READ, SUBJECTS.PUBLIC);

    return build({ detectSubjectType });
};

const defineRulesFromPermissions = (permissions = []) => {
    const { can, build } = new AbilityBuilder(createMongoAbility);

    permissions.forEach(perm => {
        can(perm.action, perm.subject, perm.conditions);
    });

    return build({ detectSubjectType });
};

export const AbilityProvider = ({ children }) => {
    const { user, isAuthenticated } = useAuth();
    const [ability, setAbility] = useState(() => defineRulesForGuest());

    useEffect(() => {
        if (isAuthenticated && user?.employee?.permissions) {
            const newAbility = defineRulesFromPermissions(user.employee.permissions);
            setAbility(newAbility);
        } else {
            setAbility(defineRulesForGuest());
        }
    }, [isAuthenticated, user, user?.employee]);

    return (
        <AbilityContext.Provider value={{ ability }}>
            {children}
        </AbilityContext.Provider>
    );
};

export function useAbility() {
    const context = useContext(AbilityContext);
    if (!context) {
        throw new Error('useAbility must be used within an AbilityProvider');
    }
    return context.ability;
}